export default function WhenNeeded() {
  const signs = [
    'сотрудники постоянно приходят с вопросами вместо самостоятельных решений',
    'приходится всё контролировать лично — без вас ничего не работает',
    'команда не проявляет инициативу и ждёт указаний по любому поводу',
    'задачи выполняются не вовремя или срываются сроки',
    'сотрудники сопротивляются любым изменениям и нововведениям',
    'сильные специалисты уходят из компании без явных причин',
    'руководитель постоянно «тушит пожары» вместо стратегической работы',
    'отдел работает только под жёстким контролем и давлением',
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Когда руководителю действительно необходимо обучение
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Если вы узнали хотя бы 3-4 признака в своей управленческой практике — системное обучение руководителей даст максимальный эффект
        </p>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-10">
            <div className="grid sm:grid-cols-2 gap-4">
              {signs.map((sign, i) => (
                <div key={i} className="flex items-start gap-3 p-3 rounded-lg hover:bg-teal-50 transition-colors group">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform">
                    <i className="ri-check-line text-xs text-white"></i>
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{sign}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}